import { render, staticRenderFns } from "./request-stats-gauge.vue?vue&type=template&id=9f4520c4&scoped=true&"
import script from "./request-stats-gauge.vue?vue&type=script&lang=js&"
export * from "./request-stats-gauge.vue?vue&type=script&lang=js&"
import style0 from "./request-stats-gauge.vue?vue&type=style&index=0&id=9f4520c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4520c4",
  null
  
)

export default component.exports